import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { EmployeeSalaryDetails } from '../shared';
import {
    TopLevelComponent,
    ISelectableItem,
} from '../../shared';
import { PagePreloaderComponent } from '../../shared/ui';
import {
    Store,
    StoreHelper,
    UserService,
} from '../../shared/services';
import { EmployeesService } from '../shared/services';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'salary-details',
    template: require('./salary-details.component.pug')
})
export class SalaryDetailsComponent implements OnInit, OnDestroy {
    @ViewChild(PagePreloaderComponent) preloader;

    items: ISelectableItem[] = [
        { id: 1, name: 'Salary', selected: true },
        { id: 2, name: 'Sales' },
        { id: 3, name: 'Commissions' },
        { id: 4, name: 'Hourly Salary' },
        { id: 5, name: 'Avg sales per hour' },
        { id: 6, name: 'Deductions' },
        { id: 7, name: 'Reimbursements' },
       
    ];

    sectionSelected: ISelectableItem;
    salaryDetails = new EmployeeSalaryDetails(null);

    private _salariesSubs: Subscription;

    constructor(
        private _employeesService: EmployeesService,
        store: Store) {

        let that = this;
        let storeState = store.getState();

        this._salariesSubs = this._employeesService.getSalaryDetails(storeState.employeeInvoicesFilter)
            .subscribe(res => {
                that.salaryDetails = res[0];
                that.preloader.hide();
            });
    }

    ngOnInit() {
        this.sectionSelected = this.items[0];
    }

    ngOnDestroy() {
        this._salariesSubs.unsubscribe();
    }

    onItemClicked(item: ISelectableItem) {
        this.sectionSelected = item;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/employees/salaries/salary-details.component.ts